




import { useFormikContext } from "formik";
import PhoneInput from "react-phone-input-2";
import { useSelector } from "react-redux";

const Phone = ({ value, name, onChange, disabled = false }) => {

  const { theme } = useSelector((state) => state.theme);

  const { setFieldValue } = useFormikContext();

  const handlePhoneChange = (phone) => {
    setFieldValue(name, phone);
    onChange?.(phone);
  };

  const containerStyles = {
    width: "100%",
    borderRadius: '0',
    backgroundColor: theme === 'light' ? '':'#232223',
    color: theme === "light" ? '#000' : '#000',
  };
  
  const inputStyles = {

    width: "100%",
    borderRadius: '0',
    backgroundColor: theme === 'light' ? '':'#232223',
    color: theme === "light" ? '#000' : '#fff',
  };

  return (
    <PhoneInput
      country={"gh"}
      value={value}
      onChange={handlePhoneChange}
      countryCodeEditable={false}
      disableSearchIcon={true}
      inputProps={{
        name,
        required: true,
        autoFocus: true,
        disabled,
      }}
      containerStyle={containerStyles}
      inputStyle={inputStyles}
      disabled={disabled}
    />
  );
};

export default Phone;
